import { IconButton } from '@affine/component';
import { AffineErrorBoundary } from '@affine/core/components/affine/affine-error-boundary';
import { SidebarRightIcon } from '@docnboard/icons/rc';
import {
  GlobalContextService,
  useLiveData,
  useService,
} from '@toeverything/infra';
import clsx from 'clsx';
import { Suspense, useCallback, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { AppSidebarService } from '../../app-sidebar';
import { SidebarSwitch } from '../../app-sidebar/views';
import { ViewService } from '../services/view';
import { WorkbenchService } from '../services/workbench';
import * as styles from './route-container.css';
import { useActiveSidebar } from './use-is-active-sidebar';
import { useViewPosition } from './use-view-position';
import { ViewBodyTarget, ViewHeaderTarget } from './view-islands';

export interface Props {
  route: {
    Component: React.ComponentType;
  };
}

const ToggleButton = ({
  onToggle,
  className,
  show,
}: {
  onToggle?: () => void;
  className: string;
  show: boolean;
}) => {
  return (
    <IconButton
      size="24"
      onClick={onToggle}
      className={className}
      data-show={show}
    >
      <SidebarRightIcon />
    </IconButton>
  );
};

export const RouteContainer = () => {
  const viewPosition = useViewPosition();
  const appSidebarService = useService(AppSidebarService).sidebar;
  const leftSidebarOpen = useLiveData(appSidebarService.open$);
  const workbench = useService(WorkbenchService).workbench;
  const view = useService(ViewService).view;
  /*DNB_FIX activeRightSidebar вместо sidebarOpen*/
  /*const sidebarOpen = useLiveData(workbench.sidebarOpen$);*/

  /*  DNB_FIX */
  const { activeRightSidebar, RIGHT_SIDEBAR, globalStateChange, isSharedMode } =
    useActiveSidebar();

  // DNB_FIX
  useEffect(() => {
    if (!isSharedMode && activeRightSidebar) {
      workbench.toggleSidebar();
    }
  }, [activeRightSidebar, workbench, isSharedMode]);

  const handleToggleSidebar = useCallback(() => {
    /*  DNB_FIX */
    /*workbench.toggleSidebar();*/
    globalStateChange(RIGHT_SIDEBAR, true);
  }, [RIGHT_SIDEBAR, globalStateChange]);

  // DNB_FIX
  const pageId = useLiveData(
    useService(GlobalContextService).globalContext.docId.$
  );

  return (
    <div className={styles.root}>
      <div
        className={clsx(styles.header, {
          'full-screen': pageId,
        })}
      >
        {!BUILD_CONFIG.isElectron && viewPosition.isFirst && (
          <SidebarSwitch
            show={!leftSidebarOpen}
            className={styles.leftSidebarButton}
          />
        )}
        <ViewHeaderTarget
          viewId={view.id}
          className={styles.viewHeaderContainer}
        />
        {/* DNB_FIX проверять на isSharedMode */}
        {!BUILD_CONFIG.isElectron && viewPosition.isLast && !isSharedMode && (
          <ToggleButton
            show={/*  DNB_FIX */ /*!sidebarOpen*/ !activeRightSidebar}
            className={styles.rightSidebarButton}
            onToggle={handleToggleSidebar}
          />
        )}
      </div>

      <AffineErrorBoundary>
        <Suspense>
          <Outlet />
        </Suspense>
      </AffineErrorBoundary>
      <ViewBodyTarget viewId={view.id} className={styles.viewBodyContainer} />
    </div>
  );
};
